import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { User } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Avatar, AvatarFallback } from '../ui/avatar';
import LocationSelector from './LocationSelector';

const Header = ({ collapsed, title, sidebarHidden }) => {
  const { user, logout } = useAuth();

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <header className={`header ${sidebarHidden ? 'header-full' : (collapsed ? 'header-collapsed' : '')}`}>
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-semibold text-stone-900">{title}</h1>
      </div>

      <div className="flex items-center gap-4">
        {/* Location Selector */}
        <LocationSelector />

        {/* User menu */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-3 hover:bg-stone-100 rounded-lg p-2 transition-colors" data-testid="user-menu-btn">
              <Avatar className="h-8 w-8">
                <AvatarFallback className="bg-teal-700 text-white text-sm">
                  {getInitials(user?.full_name)}
                </AvatarFallback>
              </Avatar>
              <div className="text-left hidden md:block">
                <p className="text-sm font-medium text-stone-900">{user?.full_name}</p>
                <p className="text-xs text-stone-500 capitalize">{user?.role?.replace('_', ' ')}</p>
              </div>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>My Account</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="cursor-pointer">
              <User className="w-4 h-4 mr-2" />
              Profile
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="cursor-pointer text-rose-600" onClick={logout}>
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
};

export default Header;
